var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-menu"},[_c('button',[_vm._v("1. Upload Statement")]),_vm._v(" > "),_c('button',[_vm._v("2. Upload Remittance")]),_vm._v(" > "),_c('button',[_vm._v("3. Select Payments")]),_vm._v(" > "),_c('button',[_vm._v("4. Complete")])])
}]

export { render, staticRenderFns }